import modalHandler from './modalHandler';

export default function modals () {
    const anchorElements = document.querySelectorAll('a[href^="#"]');
    const popups = modalHandler();
    const availableModals = Array.from(document.querySelectorAll('.cdl-modals')).map(modal => modal.getAttribute('data-modal')); // Collect data-modal attributes into an array

    anchorElements.forEach(anchor => {
        anchor.addEventListener('click', e => {
            const modal_ID = e.currentTarget.href.split('#')[1];

            // Check if modal_ID exists in the array of availableModals
            if (availableModals.includes(modal_ID)) {
                e.preventDefault();
                popups.openModal(modal_ID); // Open the modal if it exists
                // console.log(`Opening modal: ${modal_ID}`);
            }
        });
    });
}
